import React, { forwardRef, useContext } from "react";
import { Icon } from "semantic-ui-react";
import { ThemeContext } from "../contexts/ThemeContext";

const ToggleButton = forwardRef((props, ref) => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <button
      ref={ref}
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === "light" ? "dark" : "light"} theme`}
      {...props}
    >
      <Icon name={theme === "light" ? "moon" : "sun"} />
    </button>
  );
});

export default ToggleButton;
